import React from "react";
import { getTranslation } from "../../../../../components/TranslationWrapper/TranslationWrapper.tsx";
import Button from "../../../../../components/CustomButtons/Button";
import { Add } from "@mui/icons-material";
import { withStyles } from "tss-react/mui";
import ButtonBarStyle from "../../Custombuttons/Components/ButtonbarStyle";

function ButtonbarAccounts({ ...props }) {
  const { classes } = props;

  const buttons = [
    {
      color: "primary",
      label: getTranslation("vestigingen.form.account.buttonbar.label.mapping", "Mapping"),
      type: "accounts",
      checkoutField: false,
    },
  ].map((value, key) => {
    return props.checkoutShowCheckoutFields === undefined ||
      props.checkoutShowCheckoutFields ||
      (!props.checkoutShowCheckoutFields && !value.checkoutField) ? (
      <Button
        className={classes.middleButton}
        color={value.color}
        disabled={props.disableAll}
        key={key}
        onClick={() => props.onClick(value.type)}
        size={"sm"}
      >
        {value.label}
      </Button>
    ) : null;
  });

  return (
    <div className={classes.buttonGroup}>
      <Button className={classes.firstButton + " " + classes.plusButton} disabled justIcon size={"sm"}>
        <Add />
      </Button>
      {buttons}
    </div>
  );
}

export default withStyles(ButtonbarAccounts, ButtonBarStyle);
